module.exports = __webpack_public_path__ + "img/77303.c609af91.svg";